import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetConsumerPickupMovesQueryVariables = Types.Exact<{
  customerIds: Array<Types.Scalars['bigint']['input']> | Types.Scalars['bigint']['input'];
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetConsumerPickupMovesQuery = { __typename?: 'query_root', moves: Array<{ __typename?: 'moves', id: number, consumer_name?: string | null, consumer_phone?: string | null, consumer_pickup?: boolean | null, consumer_type?: string | null, reference_num?: string | null, status?: string | null, cancel_status?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, ready_by?: string | null, lite: boolean, customer?: { __typename?: 'customers', id: number, name?: string | null } | null }> };


export const GetConsumerPickupMovesDocument = gql`
    query getConsumerPickupMoves($customerIds: [bigint!]!, $start: timestamptz!, $end: timestamptz!) {
  moves(
    where: {active: {_eq: 1}, consumer_pickup: {_eq: true}, _and: [{_or: [{customer_id: {_in: $customerIds}}, {payer_id: {_in: $customerIds}}]}, {ready_by: {_gte: $start, _lte: $end}}]}
    order_by: {ready_by: desc}
    limit: 200
  ) {
    id
    consumer_name
    consumer_phone
    consumer_pickup
    consumer_type
    reference_num
    status
    cancel_status
    vehicle_color
    vehicle_make
    vehicle_model
    vehicle_stock
    vehicle_vin
    vehicle_year
    ready_by
    lite
    customer {
      id
      name
    }
  }
}
    `;

/**
 * __useGetConsumerPickupMovesQuery__
 *
 * To run a query within a React component, call `useGetConsumerPickupMovesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerPickupMovesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerPickupMovesQuery({
 *   variables: {
 *      customerIds: // value for 'customerIds'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetConsumerPickupMovesQuery(baseOptions: Apollo.QueryHookOptions<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables> & ({ variables: GetConsumerPickupMovesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>(GetConsumerPickupMovesDocument, options);
      }
export function useGetConsumerPickupMovesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>(GetConsumerPickupMovesDocument, options);
        }
// @ts-ignore
export function useGetConsumerPickupMovesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>;
export function useGetConsumerPickupMovesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConsumerPickupMovesQuery | undefined, GetConsumerPickupMovesQueryVariables>;
export function useGetConsumerPickupMovesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>(GetConsumerPickupMovesDocument, options);
        }
export type GetConsumerPickupMovesQueryHookResult = ReturnType<typeof useGetConsumerPickupMovesQuery>;
export type GetConsumerPickupMovesLazyQueryHookResult = ReturnType<typeof useGetConsumerPickupMovesLazyQuery>;
export type GetConsumerPickupMovesSuspenseQueryHookResult = ReturnType<typeof useGetConsumerPickupMovesSuspenseQuery>;
export type GetConsumerPickupMovesQueryResult = Apollo.QueryResult<GetConsumerPickupMovesQuery, GetConsumerPickupMovesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/moves/queries/getConsumerPickupMoves.query.gql}
 */
export async function getConsumerPickupMoves(
  variables: GetConsumerPickupMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetConsumerPickupMovesQuery['moves']>
export async function getConsumerPickupMoves(
  variables: GetConsumerPickupMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetConsumerPickupMovesQuery>
export async function getConsumerPickupMoves(
  variables: GetConsumerPickupMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetConsumerPickupMovesQuery['moves'] | GetConsumerPickupMovesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetConsumerPickupMovesQuery>(
    GetConsumerPickupMovesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}